import React from 'react';
import PropTypes from 'prop-types';
import PageSection from './PageSection';

export const RADAR_HERO_IMAGE = '//images.ctfassets.net/gtqjh9j40j4m/5kaMNRdmHCXsXmyMWStzt5/16bdf8d7bde3c450d64f5446a6872f1a/spychology-desktop-header_3x.jpg';

const RadarHeroPageSection = ({ children, center, container }) => (
  <PageSection
    hero
    backgroundImage={{ url: RADAR_HERO_IMAGE }}
    center={center}
    container={container}
  >
    {children}
  </PageSection>
);

RadarHeroPageSection.defaultProps = {
  center: true,
  container: true,
};

RadarHeroPageSection.propTypes = {
  children: PropTypes.node.isRequired,
  center: PropTypes.bool,
  container: PropTypes.bool,
};

export default RadarHeroPageSection;
